import { useMutation, useQuery } from "@apollo/client";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import moment from "moment";
import { EDIT_CUSTOMER } from "../apollo/mutations";
import closeModal from "../common/closeModal";
import { getCities, getCountries, getStates } from "../utils/country";
import { payloadValidator } from "../utils/helperFunctions";
import { CUSTOMER_DETAIL } from "../apollo/queries";

const defaultValues = {
  id: "",
  full_name: "",
  email: "",
  phone: "",
  balance: "",
  user_id: "",
  walk_in: false,
  business: {
    name: "",
    type: "",
    license: "",
    ein_number: "",
    license_expiry: "",
    license_no: "",
    address: {
      address: "",
      country: "",
      city: "",
      state: "",
      zip: "",
    },
  },
};

const useEditCustomer = (customerId, refetch) => {
  const [countries, setCountries] = useState(getCountries());
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedState, setSelectedState] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);

  console.log(selectedCountry, selectedState, selectedCity, setCountries);

  const {
    control,
    handleSubmit,
    reset,
    watch,
    setValue,
    formState: { errors },
  } = useForm({ defaultValues });

  const {
    loading,
    data,
    refetch: refetchCustomerDetails,
  } = useQuery(CUSTOMER_DETAIL, {
    skip: !customerId,
    variables: { customerDetailId: customerId },
    onCompleted: (data) => {
      if (!data?.customerDetail) return;
      const customerDetail = data.customerDetail;
      const business = customerDetail.business?.[0] || {};
      const address = business.address || {};

      const foundCountry =
        countries.find((item) => item.value === address.country) || null;
      const foundState = foundCountry
        ? getStates(foundCountry.country_id).find(
            (item) => item.value === address.state
          ) || null
        : null;
      const foundCity = foundState
        ? getCities(foundCountry.country_id, foundState.state_id).find(
            (item) => item.value === address.city
          ) || null
        : null;

      setSelectedCountry(foundCountry);
      setSelectedState(foundState);
      setSelectedCity(foundCity);

      console.log("customerDetail", customerDetail)

      reset({
        id: customerDetail.id,
        full_name: customerDetail.full_name,
        email: customerDetail.email,
        phone: customerDetail.phone,
        user_id: customerDetail?.user_id == null ? "" : customerDetail?.user_id,
        walk_in: customerDetail?.walk_in,
        balance:
          customerDetail?.balance == 0
            ? ""
            : customerDetail?.balance.toString(),
        business: {
          id: business.id,
          name: business.name,
          type: business.type,
          license: business.license == null ? null : business.license,
          ein_number: business.ein_number == null ? null : business.ein_number,
          license_expiry: business.license_expiry
            ? moment(parseInt(business.license_expiry)).format("YYYY-MM-DD")
            : null,
          license_no: business.license_no == null ? null : business.license_no,
          address: {
            address: address.address || "",
            country: foundCountry,
            state: foundState,
            city: foundCity,
            zip: address.zip || "",
          },
        },
      });
    },
  });

  useEffect(() => {
    if (customerId) refetchCustomerDetails();
  }, [customerId, refetchCustomerDetails]);

  const resetField = (field) => setValue(field, "");

  const [submit] = useMutation(EDIT_CUSTOMER);

  const onEditCustomer = async (data) => {
    try {
      const payload = payloadValidator({
        id: data?.id ?? "",
        full_name: data.full_name ?? "",
        email: data.email || null,
        phone: data.phone ?? "",
        user_id: data.user_id == "" ? null : parseInt(data.user_id),
        balance: parseFloat(data.balance) ?? "",
        walk_in: data?.walk_in,
        business: [
          {
            ...data.business,
            address: {
              address: data.business?.address?.address || "",
              city: data.business?.address?.city?.value || "",
              state: data.business?.address?.state?.value || "",
              country: data.business?.address?.country?.value || "",
              zip: data.business?.address?.zip || "",
            },
          },
        ],
      });

      if (payload) {
        console.log("payload", payload);
        await submit(payload);
        reset(defaultValues);
        refetch();
        closeModal("edit-units");
      }
    } catch (error) {
      console.error("Mutation error:", error.message);
    }
  };

  const country = watch("business.address.country");
  const state = watch("business.address.state");

  return {
    values: {
      control,
      errors,
      loading,
      data,
      countries,
      states: country ? getStates(country.country_id) : [],
      cities:
        country && state ? getCities(state.country_id, state.state_id) : [],
    },
    functions: { onSubmit: handleSubmit(onEditCustomer), resetField },
  };
};

export default useEditCustomer;
